<div class="flex-wrap">
    <div class="flex-100">
        <mat-card appearance="outlined">
            <mat-card-header>
                <mat-card-title>
                    <span>{{ '@information' | translate }}:</span>
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div class="flex flex-100" *ngIf="buildConfiguration.vehicleType?.toLowerCase() === 'trailer'">
                    <mat-slide-toggle class="padded-input" color="primary" (change)="toggleAttr('HasLiftGateBattery')"
                        [checked]="hasLiftGateBattery">
                        {{'@hasLiftGate' | translate}}
                    </mat-slide-toggle>
                    <mat-slide-toggle class="padded-input" color="primary" (change)="toggleAttr('HasABS')"
                        [checked]="hasABS">
                        {{ '@hasABS' | translate}}
                    </mat-slide-toggle>
                    <mat-slide-toggle class="padded-input" color="primary" (change)="toggleAttr('HasATIS')"
                        [checked]="hasATIS">
                        {{ '@hasATIS' | translate }}
                    </mat-slide-toggle>
                </div>
                <mat-form-field class="padded-input third-sized">
                    <mat-label>{{ '@name' | translate }}</mat-label>
                    <input matInput [(ngModel)]="vehicle.name" required>
                </mat-form-field>
                <mat-form-field class="padded-input third-sized">
                    <mat-label>{{ '@weightRating' | translate }}</mat-label>
                    <input matInput [(ngModel)]="buildConfiguration.grossVehicleWeightRating">
                </mat-form-field>
                <mat-form-field class="padded-input third-sized">
                    <mat-label>{{ '@cabType' | translate }}</mat-label>
                    <input matInput [(ngModel)]="buildConfiguration.bodyCabType">
                </mat-form-field>
                <mat-form-field class="padded-input">
                    <mat-label>{{ '@modelId' | translate }}</mat-label>
                    <input matInput [(ngModel)]="buildConfiguration.modelId">
                </mat-form-field>
                <mat-form-field class="padded-input">
                    <mat-label>{{ '@series' | translate }}</mat-label>
                    <input matInput [(ngModel)]="buildConfiguration.series">
                </mat-form-field>
                <mat-form-field class="padded-input">
                    <mat-label>{{ '@type' | translate }}</mat-label>
                    <input matInput [(ngModel)]="buildConfiguration.vehicleType">
                </mat-form-field>
                <mat-form-field class="padded-input">
                    <mat-label>{{ '@axles' | translate }}</mat-label>
                    <input matInput [(ngModel)]="buildConfiguration.axles">
                </mat-form-field>
                <mat-form-field class="padded-input">
                    <mat-label>{{ '@driveType' | translate }}</mat-label>
                    <input matInput [(ngModel)]="buildConfiguration.driveType">
                </mat-form-field>
                <mat-error
                    *ngIf="buildConfiguration.driveType === '' && buildConfiguration.vehicleType?.toLowerCase() !== 'trailer'"
                    style="display: inline-block;">
                    {{ '@incompleteDriveTypeError' | translate }}
                    <!-- Vehicle drive type is incomplete, data displayed for tires may be incorrect -->
                </mat-error>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="flex-100">
        <mat-card appearance="outlined">
            <mat-card-header>
                <mat-card-title>
                    <span>{{ '@engine' | translate }}:</span>
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <mat-form-field class="padded-input">
                    <mat-label>{{ '@manufacturer' | translate }}</mat-label>
                    <input matInput [(ngModel)]="buildConfiguration.engineManufacturer">
                </mat-form-field>
                <mat-form-field class="padded-input third-sized">
                    <mat-label>{{ '@model' | translate }}</mat-label>
                    <input matInput [(ngModel)]="buildConfiguration.engineModel">
                </mat-form-field>
                <mat-form-field class="padded-input">
                    <mat-label>{{ '@numberOfCylinders' | translate }}</mat-label>
                    <input matInput [(ngModel)]="buildConfiguration.engineCylinders">
                </mat-form-field>
                <mat-form-field class="padded-input">
                    <mat-label>{{ '@displacementLiters' | translate }}</mat-label>
                    <input matInput [(ngModel)]="buildConfiguration.displacementL">
                </mat-form-field>
                <mat-form-field class="padded-input">
                    <mat-label>{{ '@configuration' | translate }}</mat-label>
                    <input matInput [(ngModel)]="buildConfiguration.engineConfiguration">
                </mat-form-field>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="flex-33">
        <mat-card appearance="outlined">
            <mat-card-header>
                <mat-card-title>
                    <span>{{ '@fuel' | translate }}:</span>
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <mat-form-field class="padded-input half-sized">
                    <mat-label>{{ '@fuelType' | translate }}</mat-label>
                    <input matInput [(ngModel)]="buildConfiguration.fuelTypePrimary">
                </mat-form-field>
                <mat-form-field class="padded-input half-sized">
                    <mat-label>{{ '@fuelTypeSecondary' | translate }}</mat-label>
                    <input matInput [(ngModel)]="buildConfiguration.fuelTypeSecondary">
                </mat-form-field>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="flex-33">
        <mat-card appearance="outlined">
            <mat-card-header>
                <mat-card-title>
                    <span>{{ '@transmission' | translate }}:</span>
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <mat-form-field class="padded-input half-sized">
                    <mat-label>{{ '@transmissionStyle' | translate }}</mat-label>
                    <input matInput [(ngModel)]="buildConfiguration.transmissionStyle">
                </mat-form-field>
                <mat-form-field class="padded-input half-sized">
                    <mat-label>{{ '@transmissionSpeeds' | translate }}</mat-label>
                    <input matInput [(ngModel)]="buildConfiguration.transmissionSpeeds">
                </mat-form-field>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="flex-34">
        <mat-card appearance="outlined">
            <mat-card-header>
                <mat-card-title>
                    <span>{{ '@brakeSystem' | translate }}:</span>
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <mat-form-field class="padded-input half-sized">
                    <mat-label>{{ '@brakeSystemType' | translate }}</mat-label>
                    <input matInput [(ngModel)]="buildConfiguration.brakeSystemType">
                </mat-form-field>
                <mat-form-field class="padded-input half-sized">
                    <mat-label>{{ '@description' | translate }}</mat-label>
                    <input matInput [(ngModel)]="buildConfiguration.brakeSystemDesc">
                </mat-form-field>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="flex-100" *ngIf="vehicle.vehicleFleetSchedules != null && vehicle.vehicleFleetSchedules.length > 0">
        <ng-container *ngFor="let vfs of vehicle.vehicleFleetSchedules">
            <mat-card appearance="outlined">
                <mat-card-header>
                    <mat-card-title>
                        <span>{{ '@scheduling' | translate }} ({{ vfs.name }})</span>
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <ng-container *ngFor="let da of vfs.displayAttributes">
                        <mat-form-field class="padded-input grouped">
                            <mat-label>{{da.key}}</mat-label>
                            <input type="text" matInput [matAutocomplete]="scheduleAttributeKeysList"
                                [(ngModel)]="da.value" (keyup)="filterOptions($event, da)">
                            <mat-autocomplete autoActiveFirstOption #scheduleAttributeKeysList="matAutocomplete">
                                <mat-option *ngFor="let option of da.values" [value]="option">
                                    {{option}}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </ng-container>
                    <ng-container *ngIf="vfs.displayAttributes?.length < 1">
                        <span>No default attributes for this schedule</span>
                    </ng-container>
                </mat-card-content>
            </mat-card>
        </ng-container>
    </div>
    <div class="flex-50">
        <mat-card appearance="outlined">
            <mat-card-header>
                <mat-card-title>
                    <span>{{ '@partTypes' | translate }}:</span>
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <mat-form-field class="padded-input full-sized">
                    <mat-select multiple [(ngModel)]="vehicle.partTypes">
                        <mat-option *ngFor="let partType of PartTypeValues"
                            [value]="partType.key">{{partType.value}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="flex-50" *ngIf="listDefinitions || attributes?.length > 0">
        <mat-card appearance="outlined">
            <mat-card-header>
                <mat-card-title>
                    <span>{{ '@attributes' | translate }}:</span>
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <app-attribute-list [listDefinitions]="listDefinitions"
                    [(attributesList)]="attributes"></app-attribute-list>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="flex-100">
        <div class="align-flex-right">
            <button mat-raised-button color="primary" [disabled]="!canEdit" (click)="updateVehicleConfig()">
                {{'@update' | translate}}
            </button>
        </div>
    </div>
</div>